import type {RuleFragment} from '../../../generated/types';
import {composeDescription} from '../../../lib/seo/text';
import type {OgCardData} from '../../../lib/seo/site';

/** «Состояние», «Действие» — по семейству, иначе просто «Правило» */
export function ruleKindText(item: Pick<RuleFragment, 'parent'>): string {
	return item.parent?.title || 'Правило';
}

export function ruleDescription(item: RuleFragment): string {
	return composeDescription(`${ruleKindText(item)} ${item.title}.`, item.summary || item.description);
}

export function ruleOgCard(item: RuleFragment): OgCardData {
	return {label: ruleKindText(item), title: item.title, originalTitle: item.originalTitle, subtitle: 'Правила D&D'};
}
